// extracted by mini-css-extract-plugin
export default {"aboutPage":"AboutPage_aboutPage__iQ2G4"};